module.exports = __webpack_public_path__ + "img/asker.547244eb.png";